import React, { useEffect, useState } from 'react';
import WomanImg from '../img/about/woman.png';
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';

const About = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Set a short delay before marking the component as loaded
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 100);

    // Clear the timeout to avoid any issues when the component unmounts
    return () => clearTimeout(timeout);
  }, []);

  const openGoogleDriveLink = () => {
    window.open('https://drive.google.com/drive/folders/1usAOTzsUySqcdMTSXDPuwPh_3L3ZFmP5', '_blank');
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className={`section ${loaded ? 'loaded' : ''} bg-[#7F00FF]`}>
      <div className='container mx-auto h-full relative'>
        {/* text and image wraps */}
        <div className='flex flex-col lg:flex-row h-full items-center justify-center gap-x-24 text-center lg:text-left lg:pt-16'>
          {/* image */}
          <motion.div
            initial={{ opacity: 0, y: '-80%' }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: '-80%' }}
            transition={transition1}
            className={`flex-1 max-h-100 lg:max-h-max order-2 lg:order-none overflow-hidden transition-opacity ${loaded ? 'opacity-100' : 'opacity-0'} pb-4 md:pb-0`}>
            <img src={WomanImg} alt='' style={{ opacity: 0.8, maxWidth: '100%', maxHeight: '500px' }} />
          </motion.div>

          {/* text */}
          <div className={`flex-1 pt-36 pb-14 lg:pt-0 lg:w-auto z-10 flex flex-col justify-center items-center lg:items-start transition-opacity ${loaded ? 'opacity-100' : 'opacity-0'}`}>
            <h1 className='h1'>About me</h1>
            <p className='mb-12 max-w-sm'>
              Three years of experience as a committed and meticulous
              wedding photographer. Contributed to the expansion of a
              family-owned medical company. A professional with over
              three years of experience in online businesses who's
              creative, highly structured, and efficient. Always on time
              and takes responsible care of everything.
            </p>
            <button className='btn' onClick={openGoogleDriveLink}>
              View my works
            </button>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
